module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-active.cf622445.png";